import React from "react";
import "./src/styles/global.css";
import { ActionContextProvider, createConfig } from "./src/cra";

export const wrapRootElement = ({ element }) => {
  createConfig({
    website: "Aetna Medicare",
  });
  return <ActionContextProvider>{element}</ActionContextProvider>;
};
